module.exports = __webpack_public_path__ + "static/media/express.957aeaa7.jpg";